import { FC } from 'react';
import { useTheme } from 'styled-components';

import {
  FaqAccordion,
  ReferralProgramStep,
  Typography,
} from '@libs/components';

import { ReferralUsdtBanner } from 'src/assets';
import { useTranslation } from 'src/hooks';

import {
  BlueWrapper,
  Container,
  StepsWrapper,
  QuestionsWrapper,
  DescriptionGlass,
  CustomImg,
  CustomReferralOfferIntro,
  ProgramDescOuterWrapper,
  ProgramDescInnerWrapper,
  ProgramMobileTitle,
  ProgramWebTitle,
  ProgramInfoWrapper,
} from './styles';

import {
  ENTERING_REFERAL_STEPS,
  REFERAL_FREQUENTLY_ASKED_QUESTIONS,
} from './texts';
import { InfoSection } from './InfoSection';

export const ReferralRuleDetails: FC = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <Container>
      <BlueWrapper>
        <DescriptionGlass>
          <CustomReferralOfferIntro
            firstTitle={t('referrals_bonus_info_title')}
          />
          <CustomImg src={ReferralUsdtBanner} />
        </DescriptionGlass>
      </BlueWrapper>
      <ProgramInfoWrapper>
        <ProgramDescOuterWrapper>
          <ProgramDescInnerWrapper>
            <ProgramMobileTitle
              color={colors.text.secondary}
              type="subHeadline"
              fontFamily="primaryMedium"
            >
              {t('referral_invite_friends_first_part')}{' '}
              {t('referral_percentage')}{' '}
              {t('referral_invite_friends_second_part')}
            </ProgramMobileTitle>
            <ProgramWebTitle
              color={colors.text.secondary}
              type="subHeadline"
              fontFamily="primaryMedium"
            >
              {t('referral_invite_friends_first_part')}{' '}
              <Typography
                color={colors.text.default}
                type="titleTwo"
                fontFamily="primaryBold"
              >
                {t('referral_percentage')}{' '}
              </Typography>
              <Typography color={colors.text.secondary}>
                {t('referral_invite_friends_second_part')}
              </Typography>
            </ProgramWebTitle>
          </ProgramDescInnerWrapper>
        </ProgramDescOuterWrapper>
      </ProgramInfoWrapper>

      <InfoSection title={t('referral_how_to_enter_program')}>
        <StepsWrapper>
          {ENTERING_REFERAL_STEPS.map(({ desc }, index) => (
            <ReferralProgramStep desc={t(desc)} index={index + 1} key={index} />
          ))}
        </StepsWrapper>
      </InfoSection>
      <InfoSection title={t('referral_programs')} shouldHavePadding={false}>
        <QuestionsWrapper>
          {REFERAL_FREQUENTLY_ASKED_QUESTIONS.map(
            ({ question, answer }, index) => {
              return (
                <FaqAccordion
                  title={t(question)}
                  key={index}
                  description={answer.map((e) => t(e))}
                  titleSize="headline"
                  titleFont="primaryBold"
                />
              );
            }
          )}
        </QuestionsWrapper>
      </InfoSection>
    </Container>
  );
};

export default ReferralRuleDetails;
